<template>
  <span
    :class="['notification-dot', 'attention-dot', { 'is-still': still }]"
    :style="{ height: `${size}px`, width: `${size}px` }"
  ></span>
</template>

<script>
export default {
  name: 'NotificationDot',
  props: {
    size: {
      type: Number,
      default: 12
    },
    // No pulse: a quiet marker, as on Matchningar in Matchningsvy v3.
    still: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.notification-dot {
  position: absolute;
  border-radius: 50%;
  right: -5px;
  background-color: var(--Primary-Color);
  animation: pulse 2s infinite;
  border: 2px solid white;
  top: -1px;

  &.is-still {
    animation: none;
  }

  &.menu-item-visible {
    top: 24px;
    @media ($large-desktop) {
      right: 2px;
    }
  }
}
</style>
